import React from "react";

const Delete = () => {
  return (
    <div>
      <p> You can delete data by following the instructions below:</p>
      <ol>
        <li>Go to your account details tab</li>
        <li>Click on settings icon</li>
        <li>Click on "Delete account"</li>
        <li>Verify your account by adding password</li>
        <li>Confirm to initiate the deletion process</li>
      </ol>
      Your account will be deleted within few seconds.
    </div>
  );
};

export default Delete;
